import schemas from '../../../modules/shared/yup/yupImporterSchemas'
import { i18n } from '../../../i18n'

export default [
  {
    name: 'fintonicId',
    label: i18n('entities.subcategory.fields.fintonicId'),
    schema: schemas.string(
      i18n('entities.subcategory.fields.fintonicId'),
      {},
    ),
  },
  {
    name: 'name',
    label: i18n('entities.subcategory.fields.name'),
    schema: schemas.string(
      i18n('entities.subcategory.fields.name'),
      {},
    ),
  },
  {
    name: 'shortname',
    label: i18n('entities.subcategory.fields.shortname'),
    schema: schemas.string(
      i18n('entities.subcategory.fields.shortname'),
      {},
    ),
  },
  {
    name: 'categoryId',
    label: i18n('entities.subcategory.fields.categoryId'),
    schema: schemas.string(
      i18n('entities.subcategory.fields.categoryId'),
      {},
    ),
  },
  {
    name: 'logo',
    label: i18n('entities.subcategory.fields.logo'),
    schema: schemas.images(
      i18n('entities.subcategory.fields.logo'),
      {},
    ),
  },
]
